<li data-id="{{item.id}}" data-index="{{index}}" class="btn list-item {{stateClass}}">
        <span class="message-item">
        <h3>{{field0}}</h3>
        <p>{{subName}}</p>
            {{#if hasNewMessages}}<span class="count">{{counter}}</span>{{/if}}
        </span>
</li>